import { httpClient } from 'repositories/HttpClientRepository';
import { sessionStore } from 'store/Session';
import AuthDecorator from './AuthDecorator';

export const authDecorator = new AuthDecorator(sessionStore, httpClient);
export type { IAuthDecorator } from './interfaces/IAuthDecorator';
